// Dicționar UI per limbă. Structură: DICT[locale].<secțiune>.<cheie>.
// RO + DE draftate de mine — DE REVIZUIT de Matei (mai ales DE pentru clienții CH).
// DE = ortografie elvețiană (ss, nu ß) + „Sie".

export const DICT = {
  // ─────────────────────────────────────── EN ───────────────────────────────────────
  en: {
    nav: { solutions: 'Solutions', articles: 'Articles', book: 'Book a call' },
    consent: {
      message: 'We load the embedded booking calendar (Cal.com), which sets a cookie, only if you accept. Decline and the booking buttons open in a new tab instead.',
      accept: 'Accept',
      decline: 'Decline',
      privacy: 'Privacy Policy',
    },
    hero: {
      line1: 'Custom software, built around',
      line2a: 'the tools you ',
      em: 'already run',
      line2b: '.',
      defTail: 'noun, Romanian',
      defGloss: 'a-ți ține vorba : to keep your word',
      cta: 'Book a 15-min fit call',
      sub: "The internal tools, integrations and AI your team keeps rebuilding in spreadsheets — wired into NetSuite, your CRM and the systems you've already got. Owned by you. Shipped in weeks.",
    },
    portfolio: { eyebrow: 'Interactive demos', sub: 'Real tools we built — click in.', open: 'Open demo' },
    products: {
      eyebrow: 'what we build',
      h1: 'Software that fits,',
      h2em: 'not software you fit into.',
      why: 'why this works',
      theProblem: 'The problem',
      whatWeBuild: 'What we build',
    },
    services: { eyebrow: 'What we do' },
    founders: { eyebrow: "Who you'll work with", connect: 'connect on linkedin' },
    contact: {
      eyebrow: 'Contact',
      available: 'available this week',
      note: 'Calendar invite from Alex or Matei within 24h. No follow-up sequences.',
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    },
    solutions: {
      back: '← vorba.dev',
      eyebrow: 'Solutions',
      h1: 'Pick the department',
      h2pre: 'where it ',
      h2em: 'hurts',
      h2post: '.',
      sub: 'Five places we build custom internal tools, integrations and AI — wired into NetSuite and the systems you already run.',
      ctaEyebrow: 'Not sure which fits?',
      ctaHeading: 'Book a 15-min fit call.',
      ctaSub: 'Bring your problem. We tell you straight whether we can build it and how fast.',
      cta: 'Book a 15-min fit call',
    },
    dept: {
      back: '← vorba.dev',
      problems: 'The problems we solve',
      build: 'What we build',
      why: 'Why custom wins here',
      getStarted: 'Get started',
      ctaHeading: 'Book a 15-min fit call.',
      ctaSub: 'No slides. Bring your problem, we tell you straight whether we can build it and how fast.',
      cta: 'Book a 15-min fit call',
      seeDemo: 'See the demo',
      conceptPreview: 'Concept preview',
    },
    articles: {
      back: '← vorba.dev',
      eyebrow: 'Articles',
      heading: 'Software, automation and regulation — in plain words.',
      soon: 'Coming soon.',
    },
    footer: {
      book: 'Book a call',
      kept: 'kept since 2026',
      cities: 'Bucharest · Zürich',
      privacy: 'Privacy',
      terms: 'Terms',
      imprint: 'Imprint',
    },
  },

  // ─────────────────────────────────────── RO ───────────────────────────────────────
  ro: {
    nav: { solutions: 'Soluții', articles: 'Articole', book: 'Programează o discuție' },
    consent: {
      message: 'Încărcăm calendarul de programări integrat (Cal.com), care setează un cookie, doar dacă accepți. Dacă refuzi, butoanele de programare se deschid într-un tab nou.',
      accept: 'Accept',
      decline: 'Refuz',
      privacy: 'Politica de confidențialitate',
    },
    hero: {
      line1: 'Software custom, construit în jurul',
      line2a: 'uneltelor pe care le ',
      em: 'folosești deja',
      line2b: '.',
      defTail: 'substantiv, română',
      defGloss: 'a-ți ține vorba : a-ți ține cuvântul',
      cta: 'Programează un call de 15 min',
      sub: 'Uneltele interne, integrările și AI-ul pe care echipa ta le tot reface în Excel — conectate la sistemele pe care le ai deja. Ale tale. Livrate în săptămâni.',
    },
    portfolio: { eyebrow: 'Demo-uri interactive', sub: 'Unelte reale construite de noi — intră în ele.', open: 'Deschide demo' },
    products: {
      eyebrow: 'ce construim',
      h1: 'Software care ți se potrivește,',
      h2em: 'nu software în care te înghesui tu.',
      why: 'de ce funcționează',
      theProblem: 'Problema',
      whatWeBuild: 'Ce construim',
    },
    services: { eyebrow: 'Ce facem' },
    founders: { eyebrow: 'Cu cine vei lucra', connect: 'conectează-te pe linkedin' },
    contact: {
      eyebrow: 'Contact',
      available: 'disponibili săptămâna asta',
      note: 'Invitație în calendar de la Alex sau Matei în 24h. Fără secvențe de follow-up.',
      days: ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
      months: ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sep.', 'oct.', 'nov.', 'dec.'],
    },
    solutions: {
      back: '← vorba.dev',
      eyebrow: 'Soluții',
      h1: 'Alege departamentul',
      h2pre: 'unde ',
      h2em: 'doare',
      h2post: '.',
      sub: 'Cinci locuri unde construim software custom, integrări și automatizări pentru firme din RO și CH — conectate la uneltele pe care le folosești deja.',
      ctaEyebrow: 'Nu ești sigur care se potrivește?',
      ctaHeading: 'Programează un call de 15 min.',
      ctaSub: 'Vino cu problema ta. Îți spunem pe șleau dacă o putem construi și cât de repede.',
      cta: 'Programează un call de 15 min',
    },
    dept: {
      back: '← vorba.dev',
      problems: 'Problemele pe care le rezolvăm',
      build: 'Ce construim',
      why: 'De ce câștigă custom aici',
      getStarted: 'Hai să începem',
      ctaHeading: 'Programează un call de 15 min.',
      ctaSub: 'Fără slide-uri. Vino cu problema ta, îți spunem pe șleau dacă o putem construi și cât de repede.',
      cta: 'Programează un call de 15 min',
      seeDemo: 'Vezi demo-ul',
      conceptPreview: 'Previzualizare concept',
    },
    articles: {
      back: '← vorba.dev',
      eyebrow: 'Articole',
      heading: 'Software, automatizări și reglementări — pe înțelesul tău.',
      soon: 'În curând.',
    },
    footer: {
      book: 'Programează o discuție',
      kept: 'ne ținem de vorbă din 2026',
      cities: 'București · Zürich',
      privacy: 'Confidențialitate',
      terms: 'Termeni',
      imprint: 'Imprint',
    },
  },

  // ─────────────────────────────────────── DE ───────────────────────────────────────
  de: {
    nav: { solutions: 'Lösungen', articles: 'Artikel', book: 'Gespräch buchen' },
    consent: {
      message: 'Wir laden den eingebetteten Buchungskalender (Cal.com), der ein Cookie setzt, nur wenn Sie zustimmen. Bei Ablehnung öffnen die Buchungs-Buttons in einem neuen Tab.',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
      privacy: 'Datenschutz',
    },
    hero: {
      line1: 'Massgeschneiderte Software, gebaut um',
      line2a: 'die Tools, die Sie ',
      em: 'schon nutzen',
      line2b: '.',
      defTail: 'Substantiv, Rumänisch',
      defGloss: 'a-ți ține vorba : sein Wort halten',
      cta: '15-Min-Kennenlern-Call buchen',
      sub: 'Die internen Tools und Integrationen, die Ihre Insellösungen verbinden — bexio, Abacus, das CRM und das Excel dazwischen. Ihnen gehörend, kein Lock-in. In Wochen geliefert.',
    },
    portfolio: { eyebrow: 'Interaktive Demos', sub: 'Echte Tools, die wir gebaut haben — klicken Sie rein.', open: 'Demo öffnen' },
    products: {
      eyebrow: 'was wir bauen',
      h1: 'Software, die passt,',
      h2em: 'nicht Software, in die Sie sich pressen.',
      why: 'warum das funktioniert',
      theProblem: 'Das Problem',
      whatWeBuild: 'Was wir bauen',
    },
    services: { eyebrow: 'Was wir tun' },
    founders: { eyebrow: 'Mit wem Sie arbeiten', connect: 'auf linkedin vernetzen' },
    contact: {
      eyebrow: 'Kontakt',
      available: 'diese Woche verfügbar',
      note: 'Kalendereinladung von Alex oder Matei innert 24h. Keine Follow-up-Sequenzen.',
      days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      months: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
    },
    solutions: {
      back: '← vorba.dev',
      eyebrow: 'Lösungen',
      h1: 'Wählen Sie die Abteilung,',
      h2pre: 'wo es ',
      h2em: 'wehtut',
      h2post: '.',
      sub: 'Fünf Bereiche, in denen wir massgeschneiderte interne Tools, Integrationen und KI für Schweizer KMU bauen — verbunden mit bexio, Abacus und den Tools, die Sie schon nutzen.',
      ctaEyebrow: 'Unsicher, was passt?',
      ctaHeading: '15-Min-Kennenlern-Call buchen.',
      ctaSub: 'Bringen Sie Ihr Problem. Wir sagen Ihnen klar, ob wir es bauen können und wie schnell.',
      cta: '15-Min-Kennenlern-Call buchen',
    },
    dept: {
      back: '← vorba.dev',
      problems: 'Die Probleme, die wir lösen',
      build: 'Was wir bauen',
      why: 'Warum massgeschneidert hier gewinnt',
      getStarted: 'Loslegen',
      ctaHeading: '15-Min-Kennenlern-Call buchen.',
      ctaSub: 'Keine Slides. Bringen Sie Ihr Problem, wir sagen Ihnen klar, ob wir es bauen können und wie schnell.',
      cta: '15-Min-Kennenlern-Call buchen',
      seeDemo: 'Demo ansehen',
      conceptPreview: 'Konzept-Vorschau',
    },
    articles: {
      back: '← vorba.dev',
      eyebrow: 'Artikel',
      heading: 'Software, Automatisierung und Regulierung — verständlich erklärt.',
      soon: 'Demnächst.',
    },
    footer: {
      book: 'Gespräch buchen',
      kept: 'beim Wort seit 2026',
      cities: 'Bukarest · Zürich',
      privacy: 'Datenschutz',
      terms: 'AGB',
      imprint: 'Impressum',
    },
  },
}
